import { PaneInfoRenderer, PaneInfoPaneView, PaneInfoPrimitive } from "./pane-info";

export class MacdPanePrimitive extends PaneInfoPrimitive {
    onAttach() {
        this.renderData.mainSeries = this.series().get("mainSeries");
        this.renderData.signalSeries = this.series().get("signalSeries");
        this.renderData.histogramSeries = this.series().get("histogramSeries");
        this.renderData.macdData = this.series().get("mainSeries").data();
        this.renderData.signalData = this.series().get("signalSeries").data();
        this.renderData.histData = this.series().get("histogramSeries").data();

        const macd = this.renderData.macdData.at(-1);
        const signal = this.renderData.signalData.at(-1);
        const hist = this.renderData.histData.at(-1);
        const histPrev = this.renderData.histData.at(-2);
        this.update(macd, signal, hist, histPrev);
    }

    onMouseMove = (param) => {
        let macd, signal, hist;
        if (param) {
            const { mainSeries, signalSeries, histogramSeries } = this.renderData;
            macd = param.seriesData.get(mainSeries);
            signal = param.seriesData.get(signalSeries);
            hist = param.seriesData.get(histogramSeries);
        }
        if (macd || signal || hist) this.update(macd, signal, hist, hist?.customValues?.previousValue);
    };

    update(macd, signal, hist, histPrev) {
        const indicators = this.indicators;
        const content = [];
        content.push({ text: `MACD ${indicators.get("macd").fast} ${indicators.get("macd").slow} ` });

        if (macd && macd.value !== undefined) {
            content.push({ text: `${macd.value.toFixed(2)} `, color: indicators.get("macd").colorOptions.lineColor });
        }
        if (signal && signal.value !== undefined) {
            content.push({ text: `${signal.value.toFixed(2)} `, color: indicators.get("macd").colorOptions.signalColor });
        }
        if (hist && hist.value !== undefined) {
            content.push({ text: `${hist.value.toFixed(2)}`, color: hist.color });
        }

        this.updateContent(content);
    }
}
